export class Server {
    constructor() {
        let prefix = location.host.indexOf('localhost') === 0 ? location.origin : 'https://' + location.host;
        this.url = prefix + (window.href ? window.href('/api/') : '/tst/api/');
    }

    request(method, data, onSuccess, onError, onFinally) {
        const requestParams = {
            ...data,
        };
        const checkForError = (response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        };

        return fetch(`${this.url + method}`, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify(requestParams)
        })
            .then(checkForError)
            .then((response) => {
                if (!response.success && response.error === 'user is not logged in') {
                    window.location.reload()
                    return;
                }
                if (!response.success && typeof onError === 'function') return onError(response);
                if (typeof onSuccess === 'function') onSuccess(response);
                return response;
            })
            .catch((error) => {
                if (typeof onError === 'function') onError(error);
                console.log(error)
                return error;
            })
            .finally(() => {
                if (typeof onFinally === 'function') onFinally();
            });
    }

}
